import React from "react";
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";

export default function DatePickerInner (props) {

    const [startDate, setStartDate] = React.useState(new Date());
    const ExampleCustomInput = ({ value, onClick }) => (
      <div style={{width: '300px', height: '40px', border: '1px solid black', lineHeight: '40px', paddingLeft: '10px', background: '#ffffff'}} onClick={onClick}>
        {value}
      </div>
    );

    return (
      <DatePicker
        selected={props.selected != undefined ? props.selected : startDate}
        showTimeSelect
        timeIntervals={15}
        dateFormat="Pp"
        readOnly={props.readOnly ? props.readOnly : false}
        onChange={date => {
          setStartDate(date)
          props.onChange (date);
        }}
        customInput={<ExampleCustomInput />}
      />
    );
  };
